export const drawField = (
	field: CanvasRenderingContext2D,
	width: number,
	height: number,
) => {
	// Setup
	field.clearRect(0, 0, width, height);
	field.fillStyle = "#005700"; // "pine" color we use for jerseys
	field.fillRect(0, 0, width, height);
	field.strokeStyle = "rgb(254 254 254 / 35%)"; // "snow" color
	field.lineWidth = 1;

	// Main field markings
	field.strokeRect(1, 1, width - 2, height - 2);

	// Center elements
	field.beginPath();
	field.arc(width / 2, height / 2, 50, 0, Math.PI * 2);
	field.stroke();
	field.beginPath();
	field.moveTo(1, height / 2);
	field.lineTo(width - 1, height / 2);
	field.stroke();
	field.fillStyle = "rgb(254 254 254 / 35%)"; // "snow" color
	field.beginPath();
	field.arc(width / 2, height / 2, 3, 0, Math.PI * 2);
	field.fill();

	// Penalty areas
	const penaltyWidth = width * 0.6;
	const penaltyHeight = 80;
	field.strokeRect(
		(width - penaltyWidth) / 2,
		1,
		penaltyWidth,
		penaltyHeight
	);

	field.strokeRect(
		(width - penaltyWidth) / 2,
		height - 1 - penaltyHeight,
		penaltyWidth,
		penaltyHeight
	);

	// Goal area
	const goalAreaWidth = width * 0.3;
	const goalAreaHeight = 40;
	field.strokeRect(
		(width - goalAreaWidth) / 2,
		1,
		goalAreaWidth,
		goalAreaHeight
	);

	field.strokeRect(
		(width - goalAreaWidth) / 2,
		height - 1 - goalAreaHeight,
		goalAreaWidth,
		goalAreaHeight
	);

	// Penalty spot
	field.fillStyle = "rgb(254 254 254 / 35%)"; // "snow" color
	field.beginPath();
	field.arc(width / 2, 1 + penaltyHeight - 20, 3, 0, Math.PI * 2);
	field.fill();
	field.beginPath();
	field.arc(width / 2, height - 1 - penaltyHeight + 20, 3, 0, Math.PI * 2);
	field.fill();

	// Penalty arc ('D') at the bottom penalty box
	const penaltyArcRadiusX = penaltyWidth * 0.18;
	const penaltyArcRadiusY = 18;
	const penaltyLineYBottom = height - 1 - penaltyHeight;
	field.save();
	field.beginPath();
	field.translate(width / 2, penaltyLineYBottom);
	field.scale(penaltyArcRadiusX / penaltyArcRadiusY, 1);
	field.arc(0, 0, penaltyArcRadiusY, 0, Math.PI, true);
	field.restore();
	field.stroke();

	// Penalty arc ('D') at the top penalty box
	const penaltyLineYTop = 1 + penaltyHeight;
	field.save();
	field.beginPath();
	field.translate(width / 2, penaltyLineYTop);
	field.scale(penaltyArcRadiusX / penaltyArcRadiusY, 1);
	field.arc(0, 0, penaltyArcRadiusY, Math.PI, 2 * Math.PI, true);
	field.restore();
	field.stroke();

	// Corner arcs
	const cornerArcRadius = 15;
	field.strokeStyle = "rgb(254 254 254 / 35%)"; // "snow" color
	field.lineWidth = 1;
	field.beginPath();
	field.arc(1, 1, cornerArcRadius, 0, 0.5 * Math.PI, false);
	field.stroke();
	field.beginPath();
	field.arc(width - 1, 1, cornerArcRadius, 0.5 * Math.PI, Math.PI, false);
	field.stroke();
	field.beginPath();
	field.arc(1, height - 1, cornerArcRadius, 1.5 * Math.PI, 0, false);
	field.stroke();
	field.beginPath();
	field.arc(
		width - 1,
		height - 1,
		cornerArcRadius,
		Math.PI,
		1.5 * Math.PI,
		false
	);
	field.stroke();
};
